<template>
  <div class="CopyrightText">{{ text.replace('{year}', (new Date).getFullYear()) }}</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.CopyrightText {
  font-weight: 400;
  color: var(--text-color-muted);
}
</style>
